import type { ReactNode } from 'react';
import { AppVersionTag } from '@/shared/components/AppVersionTag';
import { AuthorizationHeroPanel } from './AuthorizationHeroPanel';

interface AuthorizationShellProps {
    children: ReactNode;
}

export function AuthorizationShell({ children }: AuthorizationShellProps) {
    return (
        <>
            <div className="flex min-h-screen">
                <section className="flex w-full flex-col justify-center bg-[#01233C] px-8 py-12 sm:w-1/2 sm:px-16 lg:px-24">{children}</section>
                <AuthorizationHeroPanel />
            </div>
            <AppVersionTag />
        </>
    );
}
